export enum AccommodationType {
    HOUSE = "HOUSE",
    HOTEL = "HOTEL"
}
